import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        first: String,
        second: String,
    };

    static targets = [
        'container',
    ];

    toggle(event) {
        event.preventDefault();

        if (this.firstValue === this.containerTarget.textContent) {
            this.containerTarget.textContent = this.secondValue;
        } else {
            this.containerTarget.textContent = this.firstValue;
        }
    }
}
